import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

window.QuizPlatform.initScript((quiz) => {
	quiz.startAutoResize();
	quiz.play();
	store.dispatch('setQuiz', quiz);

	// eslint-disable-next-line no-new
	new Vue({
		el: '#app',
		store,
		render: h => h(App)
	});
});